// ----------------------------------------------------------------------

export default function MuiChip(theme) {
  return {
    MuiChip: {
      styleOverrides: {
        root: {
          boxShadow: theme.customShadows.card,
          borderRadius: "5px",
          position: 'relative',
          zIndex: 0, // Fix Safari overflow: hidden with border radius
          backgroundColor: theme.palette.grey[300],
        },
      },
    },
  };
}
